import React, {ReactNode} from 'react';
import CLTooltip from '../../../components/CLOverlayTrigger/overlays/CLTooltip/CLTooltip';
import NoPermissionsTooltip from './NoPermissionsTooltip';

export function NoPermissionsButtonWrapper({
  children,
  isUserWithPermission,
}: {
  children: ReactNode;
  isUserWithPermission: boolean;
}) {
  return (
    <CLTooltip
      popper={<NoPermissionsTooltip />}
      tooltipShown={isUserWithPermission ? false : undefined}
    >
      {children}
    </CLTooltip>
  );
}
